import axios from 'axios';
import { API_URL, MAX_RETRY } from '../config';

axios.defaults.withCredentials = true;

export class NetworkError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NetworkError';
  }
}

export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const createLayupClient = (retry: boolean = true) => {
  let retryCount = 1;
  const client = axios.create({
    baseURL: API_URL,

    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  client.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      if (error.code === 'ERR_NETWORK' || error.code === 'ECONNABORTED' || error.code === 'ERR_CONNECTION_REFUSED') {
        if (retry && retryCount <= MAX_RETRY) {
          retryCount += 1;
          await delay(1000);
          return client(error.config);
        } else {
          return Promise.reject(new NetworkError(error.message));
        }
      }
      return Promise.reject(error);
    },
  );
  return client;
};
